import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../../environments/environment';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
var PackagesHttpService = /** @class */ (function () {
    function PackagesHttpService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    PackagesHttpService.prototype.getAllFiles = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_files_list';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    PackagesHttpService.prototype.getAllUIFiles = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_ui_list';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    PackagesHttpService.prototype.getBundleSpec = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_bundle_spec';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    PackagesHttpService.prototype.getAvailableVersions = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_avail_vers';
            var params = {
                response: false
            };
            API.get(_this.apiName, path, params).then(function (resu) {
                var lists = resu.data;
                var verArray = [];
                for (var _i = 0, lists_1 = lists; _i < lists_1.length; _i++) {
                    var list = lists_1[_i];
                    verArray.push(list.file_version);
                }
                observer.next(verArray);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    PackagesHttpService.prototype.getInCompVersions = function (comp) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/incompatibles';
            var params = {
                body: {
                    comp: comp
                }
            };
            API.post(_this.apiName, path, params).then(function (lists) {
                var verArray = [];
                for (var _i = 0, lists_2 = lists; _i < lists_2.length; _i++) {
                    var list = lists_2[_i];
                    verArray.push(list.file_version);
                }
                observer.next(verArray);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    PackagesHttpService.prototype.assignBundleSpec = function (assignObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/assignBundle';
            var params = {
                body: assignObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    PackagesHttpService.prototype.delBundleSpec = function (assignObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/removeBundle';
            var params = {
                body: assignObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    PackagesHttpService.prototype.cloudEdit = function (editedFile) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/cloudFileEdit';
            var params = {
                body: editedFile
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    PackagesHttpService.prototype.cloudDelete = function (obj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/cloud_delete';
            var params = {
                body: obj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    PackagesHttpService.prototype.getS3Obj = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_up_obj';
            var params = {
                response: false
            };
            API.get(_this.apiName, path, params).then(function (obj) {
                observer.next(obj);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    PackagesHttpService.prototype.cloudUploads = function (upObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/cloudUpload';
            var params = {
                body: upObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    PackagesHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PackagesHttpService_Factory() { return new PackagesHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: PackagesHttpService, providedIn: "root" });
    return PackagesHttpService;
}());
export { PackagesHttpService };
